/**
 * Pluggable adapter contracts for the VibeKonnect frontend module.
 *
 * A host application supplies:
 *   - AuthAdapter: how to get the current user + JWT token
 *   - Optional: DBAdapter, ThemeAdapter (server does the heavy lifting)
 *
 * Konnect's default JWT-based auth is provided out of the box.
 */

/** Default config used when embedded inside Konnect. */
export const DEFAULT_KONNECT_CONFIG = {
  apiBase: process.env.REACT_APP_BACKEND_URL,
  routePrefix: '/api/dev-console',
  theme: 'kaharian', // 'kaharian' | 'dark' | 'light'
  defaultModel: 'claude-sonnet-4-5-20250929',
  enabledAgents: ['architect', 'designer', 'developer', 'integration', 'qa'],
  branding: {
    name: 'VibeKonnect',
    accentColor: '#10b981', // emerald-500
    logo: null,             // optional URL
    tagline: 'AI builder — powered by Claude',
  },
};

/**
 * KonnectAuthAdapter — reads the JWT from localStorage under
 * `konnect_access_token`, matches what AuthContext.jsx writes.
 * Drop-in adapter for the default Konnect install.
 */
export const KonnectAuthAdapter = {
  async getToken() {
    return typeof window !== 'undefined'
      ? window.localStorage.getItem('konnect_access_token') || ''
      : '';
  },
  async isAuthenticated() {
    return !!(await this.getToken());
  },
  async getCurrentUser() {
    // The backend returns this via /api/auth/me; the caller is expected to
    // have hydrated it into AuthContext already. Left as a stub for hosts
    // that need to re-fetch.
    return null;
  },
};

/** Merge a host config over the Konnect defaults. */
export function resolveConfig(hostConfig) {
  return {
    ...DEFAULT_KONNECT_CONFIG,
    ...(hostConfig || {}),
    branding: { ...DEFAULT_KONNECT_CONFIG.branding, ...(hostConfig?.branding || {}) },
  };
}
